import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon, IconButton } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import BuilderDayTarget from './BuilderDayTarget';
import * as Actions from '../store/actions';

const styles = theme => ({
    root: {
        width: '90%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
});

class BlankCourseSchedule extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { month, mappedLessons } = this.props
        let weekStart = (month * 4) - 3
        let weekEnd = (month * 4) + 1
        let schedule = []
        for (let i = weekStart; i < weekEnd; i++) {
            schedule.push(
                <TableRow key={i}>
                    {/* <TableCell key={i + '_' + 1} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={1} weekend={true} /></TableCell> */}
                    <TableCell key={i + '_' + 2} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={2} /></TableCell>
                    <TableCell key={i + '_' + 3} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={3} /></TableCell>
                    <TableCell key={i + '_' + 4} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={4} /></TableCell>
                    <TableCell key={i + '_' + 5} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={5} /></TableCell>
                    <TableCell key={i + '_' + 6} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={6} /></TableCell>
                    {/* <TableCell key={i + '_' + 7} style={{ margin: 0, padding: 5 }}><BuilderDayTarget mappedLessons={mappedLessons} month={month} week={i} day={7} weekend={true} /></TableCell> */}
                </TableRow>
            )
        }
        return (
            <div>
                <Typography>Active Month:
                            <IconButton
                        onClick={(ev) => {
                            this.props.toggleMonth('DOWN')
                        }}
                        disabled={this.props.month === 1}
                    >
                        <Icon>keyboard_arrow_left</Icon>
                    </IconButton>
                    {this.props.month}
                    <IconButton
                        onClick={(ev) => {
                            this.props.toggleMonth('UP')
                        }}
                        disabled={this.props.month === 6}
                    >
                        <Icon>keyboard_arrow_right</Icon>
                    </IconButton>
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell>Sunday</TableCell> */}
                            <TableCell>Monday</TableCell>
                            <TableCell>Tuesday</TableCell>
                            <TableCell>Wednesday</TableCell>
                            <TableCell>Thursday</TableCell>
                            <TableCell>Friday</TableCell>
                            {/* <TableCell>Saturday</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {schedule}
                    </ TableBody>
                </Table>
            </div>


        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleMonth: Actions.toggleMonth
    }, dispatch);
}

function mapStateToProps({ validator, courseApp }) {
    return {
        month: courseApp.courses.month
    }
}
// export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(DragDropContext(HTML5Backend)(BlankCourseSchedule))));
export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(BlankCourseSchedule)));




// WEBPACK FOOTER //
// src/main/content/course/builderComponents/BlankCourseSchedule.js